import Api from 'Helpers/api';

const Categories = {
	get: async () => {
		const response = await Api.call('get', '/categories');
		return response.data;
	}
};

export default Categories;
